"use client";

import { useAuth } from "@/components/AuthContext";
import { AuthForm } from "@/components/AuthForm";
import { CinematicModal } from "@/components/ui/CinematicModal";
import { usePathname } from "next/navigation";

export function AuthModal() {
  const { isAuthModalOpen, closeAuthModal, authModalMode } = useAuth();
  const pathname = usePathname();

  return (
    <CinematicModal
      isOpen={isAuthModalOpen}
      onClose={closeAuthModal}
      maxWidth="lg"
      titleId="auth-dialog-title"
      panelClassName="inset-0 h-[100dvh] max-h-none w-full max-w-none translate-x-0 translate-y-0 rounded-none border-0 sm:inset-auto sm:left-1/2 sm:top-1/2 sm:h-auto sm:max-h-[calc(100dvh-2rem)] sm:w-[calc(100%-2rem)] sm:max-w-lg sm:-translate-x-1/2 sm:-translate-y-1/2 sm:rounded-2xl sm:border"
      contentClassName="flex min-h-full items-start px-6 pb-[calc(env(safe-area-inset-bottom)+1.5rem)] pt-[calc(env(safe-area-inset-top)+4rem)] sm:min-h-0 sm:px-8 sm:pb-8 sm:pt-8"
      closeButtonClassName="right-[max(0.75rem,env(safe-area-inset-right))] top-[max(0.75rem,env(safe-area-inset-top))] sm:right-4 sm:top-4"
    >
      <div className="mx-auto w-full max-w-md sm:max-w-none">
        <AuthForm
          redirectPath={pathname === "/maths" ? "/maths" : undefined}
          onSuccess={closeAuthModal}
          defaultMode={authModalMode}
          variant="modal"
          titleId="auth-dialog-title"
        />
      </div>
    </CinematicModal>
  );
}
